jQuery(document).ready(function ($) {
    let social = $('.singleSocialShare');

    if (!social.length || $('body').hasClass('fl-builder-edit')) {
        return;
    }

    social.stickySidebar({
        topSpacing: 120,
        bottomSpacing: 120
    });
})